<app-header
  icon="fas fa-tags"
  text="Eigene Schlagworte"
  sub="Ergänzen oder reduzieren Sie Ihren Schlagwortpool."></app-header>
<p-divider />

<app-tag-administration></app-tag-administration>
